import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select';
import { cn } from '@/lib/utils';
import { useSettingsStore } from '@/store/SettingsStore';
import { Language, LANGUAGE_NAMES, SUPPORTED_LANGUAGES } from 'intermind';
import { useCallback } from 'react';

interface LanguageSelectorProps extends React.HTMLAttributes<HTMLDivElement> {}

export default function LanguageSelector({ className, children }: LanguageSelectorProps) {
  const { language, setLanguage } = useSettingsStore();

  const handleChange = useCallback(
    (lang: Language) => {
      setLanguage(lang);
    },
    [setLanguage]
  );

  return (
    <Select value={language} onValueChange={handleChange}>
      <SelectTrigger className={cn('flex gap-1 w-auto border-0 shadow-none focus:ring-0 p-0', className)}>
        {children || <span className="text-muted-foreground">{LANGUAGE_NAMES[language]}</span>}
      </SelectTrigger>
      <SelectContent>
        {SUPPORTED_LANGUAGES.map((lang) => (
          <SelectItem key={lang} value={lang}>
            {LANGUAGE_NAMES[lang]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
